import {http} from "@/utils/http.js";

export const login = (data)=> http.request({ url: '/user/login', method: 'post', data });
